import { Injectable } from '@angular/core';
import { MainBaseApiService } from '../../../_shared/services/main-base-api.service';
import { catchError } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../../_base-shared/contracts/laravel-response.interface';
import { DepartmentCategory } from '../../../../../../_base-shared/models/Department/DepartmentCategory';
import { Observable } from 'rxjs';
import { AccomplishmentTarget } from '../../../../../../_base-shared/models/Accomplishment/AccomplishmentTarget';

@Injectable({
  providedIn: 'root'
})
export class AccomplishmentService extends MainBaseApiService {
  public show(targetId: number): Observable<LaravelResourceResponse<AccomplishmentTarget>> {
    return this.http.get<LaravelResourceResponse<AccomplishmentTarget>>(`${this.apiUrl}/accomplishment-targets/` + targetId)
      .pipe(catchError(response => this.handleError(response)));
  }

  public indexDepartmentAccomplishmentTargets(requestData = {}, relations = []): Observable<LaravelResourceResponse<DepartmentCategory[]>> {
    const params = MainBaseApiService.convertFiltersForRequest(
      {...requestData, with: relations}, 'get'
    );
    return this.http.get<LaravelResourceResponse<DepartmentCategory[]>>(`${this.apiUrl}/department-accomplishment-targets`, {params})
      .pipe(catchError(response => this.handleError(response)));
  }

  public updateDepartmentAccomplishmentTargets(requestData): Observable<LaravelResourceResponse<Array<AccomplishmentTarget>>> {
    return this.http.patch<LaravelResourceResponse<Array<AccomplishmentTarget>>>(
      this.apiUrl + '/department-accomplishment-targets', requestData
    ).pipe(catchError(response => this.handleError(response)));
  }

  public indexUserDepartmentTargets(userId: number, request = {}): Observable<LaravelResourceResponse<Array<DepartmentCategory>>> {
    const params = MainBaseApiService.convertFiltersForRequest(request, 'get');

    return this.http.get<LaravelResourceResponse<Array<DepartmentCategory>>>(
      this.apiUrl + '/users/' + userId + '/department-accomplishment-targets', {params}
    ).pipe(catchError(response => this.handleError(response)));
  }

  public updateUserDepartmentTargets(userId: number, requestData): Observable<LaravelResourceResponse<Array<DepartmentCategory>>> {
    return this.http.patch<LaravelResourceResponse<Array<DepartmentCategory>>>(
      this.apiUrl + '/users/' + userId + '/department-accomplishment-targets', requestData
    ).pipe(catchError(response => this.handleError(response)));
  }
}
